"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _StatusPill = _interopRequireDefault(require("./StatusPill.style"));
var _excluded = ["id", "name", "size", "status", "showCircle", "value"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var REWARD_STATUSES = _config["default"].REWARD_STATUSES,
  GENERAL_STATUSES_KEYS = _config["default"].GENERAL_STATUSES_KEYS;
var StatusPill = function StatusPill(_ref) {
  var id = _ref.id,
    name = _ref.name,
    size = _ref.size,
    status = _ref.status,
    showCircle = _ref.showCircle,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StatusPill["default"], _extends({
    id: id,
    name: name,
    status: status,
    size: size,
    value: value
  }, otherProps), name && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-name"
  }, name, ":"), showCircle && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-circle"
  }), value && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-value"
  }, value));
};
StatusPill.propTypes = {
  showCircle: _propTypes["default"].bool,
  /**
   * Html id for the element
   */
  id: _propTypes["default"].string,
  /**
   * The label for this element
   */
  name: _propTypes["default"].string,
  /**
   * The text size of the elements
   */
  size: _propTypes["default"].number,
  /**
   * The status one of: 'draft', 'expired', 'live', 'published'
   * 'status_draft', 'status_published', 'status_live', 'status_expired', 'status_error
   */
  status: _propTypes["default"].oneOf([].concat(_toConsumableArray(R.keys(REWARD_STATUSES)), _toConsumableArray(R.keys(GENERAL_STATUSES_KEYS)))).isRequired,
  /**
   * The status value (text)
   */
  value: _propTypes["default"].string
};
StatusPill.defaultProps = {
  showCircle: true,
  name: undefined,
  size: 12,
  id: '',
  value: ''
};
StatusPill.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StatusPill",
  "props": {
    "showCircle": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The label for this element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "12",
        "computed": false
      },
      "description": "The text size of the elements",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Html id for the element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The status value (text)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "status": {
      "description": "The status one of: 'draft', 'expired', 'live', 'published'\r\n'status_draft', 'status_published', 'status_live', 'status_expired', 'status_error",
      "type": {
        "name": "enum",
        "value": [{
          "value": "...R.keys(REWARD_STATUSES)",
          "computed": true
        }, {
          "value": "...R.keys(GENERAL_STATUSES_KEYS)",
          "computed": true
        }]
      },
      "required": true
    }
  }
};
var _default = StatusPill;
exports["default"] = _default;